import React from "react";
import {
  Button,
  Grid,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useStyles } from "./styles";
import { ErrorMessage, Formik } from "formik";
import { useNavigate, useOutletContext } from "react-router-dom";
import useCourse from "../../../../Hooks/course";
import Loader from "../../../../common/Loader";
import CustomExpandMore from "../../../../common/CustomExpandMore";

const EditCourse = () => {
  const classes = useStyles();
  const { institutionId } = useOutletContext();

  const {
    getActiveCourseData,
    updateCourseAction,
    loading,
    departmentData,
    programData,
  } = useCourse();
  const initValues = {
    code: getActiveCourseData[0]?.code,
    name: getActiveCourseData[0]?.name,
    totalSeats: getActiveCourseData[0]?.totalSeats,
    yearOfInduction: getActiveCourseData[0]?.yearOfInduction,
    idDepartment: getActiveCourseData[0]?.idDepartment,
    idProgram: getActiveCourseData[0]?.idProgram,
  };

  const navigate = useNavigate();
  return (
    <>
      {loading && <Loader />}
      <Stack className={classes.editCourse}>
        <Typography sx={{ py: 2 }} className={classes.add_course_text}>
          Update Course
        </Typography>
        <Grid container>
          <Grid item lg={10} sm={12}>
            <Stack>
              <Formik
                initialValues={initValues}
                validateOnBlur={false}
                validateOnChange={false}
                onSubmit={(values) => {
                  updateCourseAction({
                    course: {
                      ...values,
                      id: getActiveCourseData[0]?.id,
                      idDepartment: getActiveCourseData[0]?.idDepartment,
                      idProgram: getActiveCourseData[0]?.idProgram,
                      institutionId,
                    },
                  });
                }}
              >
                {(formik) => {
                  const {
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    values,
                  } = formik;
                  return (
                    <form onSubmit={handleSubmit}>
                      <Grid
                        container
                        sx={{ py: 2 }}
                        className={classes.form_add_course}
                        justifyContent="space-between"
                        spacing={6}
                      >
                        <Grid item lg={6} md={6} sx={{ width: "100%" }}>
                          <Stack
                            sx={{
                              flexDirection: "row",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <Stack>
                              <Typography className={classes.label}>
                                Course Code
                              </Typography>
                            </Stack>
                            <Stack>
                              <TextField
                                id="code"
                                name="code"
                                placeholder="Enter course code"
                                className={
                                  errors.code && touched.code
                                    ? classes.inputError
                                    : classes.inputNoError
                                }
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.code}
                              />
                            </Stack>
                          </Stack>
                        </Grid>
                        <Grid item lg={6} md={6} sx={{ width: "100%" }}>
                          <Stack
                            sx={{
                              flexDirection: "row",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <Stack>
                              <Typography className={classes.label}>
                                Program
                              </Typography>
                            </Stack>
                            <Stack>
                              <Select
                                id="idProgram"
                                name="idProgram"
                                className={
                                  errors.idProgram && touched.idProgram
                                    ? classes.inputError
                                    : classes.inputNoError
                                }
                                placeholder="what's your favourite car?"
                                displayEmpty
                                IconComponent={CustomExpandMore}
                                onChange={handleChange}
                                value={values.idProgram}
                                sx={{
                                  width: 240,
                                }}
                              >
                                <MenuItem disabled value="">
                                  <span>Select Program</span>
                                </MenuItem>
                                {programData.map((_el) => (
                                  <MenuItem value={_el.id}>{_el.name}</MenuItem>
                                ))}
                              </Select>
                              <ErrorMessage
                                name="idProgram"
                                component="span"
                                className={classes.error}
                              />
                            </Stack>
                          </Stack>
                        </Grid>
                      </Grid>
                      <Grid
                        container
                        sx={{ pb: 2 }}
                        className={classes.form_add_course}
                        justifyContent="space-between"
                        spacing={6}
                      >
                        <Grid item lg={6} md={6} sx={{ width: "100%" }}>
                          <Stack
                            sx={{
                              flexDirection: "row",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <Stack>
                              <Typography className={classes.label}>
                                Course Name
                              </Typography>
                            </Stack>
                            <Stack>
                              <TextField
                                id="name"
                                name="name"
                                placeholder="Enter course name"
                                className={
                                  errors.name && touched.name
                                    ? classes.inputError
                                    : classes.inputNoError
                                }
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.name}
                              />
                            </Stack>
                          </Stack>
                        </Grid>
                        <Grid item lg={6} md={6} sx={{ width: "100%" }}>
                          <Stack
                            sx={{
                              flexDirection: "row",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <Stack>
                              <Typography className={classes.label}>
                                Department
                              </Typography>
                            </Stack>
                            <Stack>
                              <Select
                                id="idDepartment"
                                name="idDepartment"
                                className={
                                  errors.idDepartment && touched.idDepartment
                                    ? classes.inputError
                                    : classes.inputNoError
                                }
                                value={values.idDepartment}
                                onChange={handleChange}
                                placeholder="what's your favourite car?"
                                IconComponent={CustomExpandMore}
                                sx={{
                                  width: 240,
                                }}
                                displayEmpty
                              >
                                <MenuItem disabled value="">
                                  <span>Select Department</span>
                                </MenuItem>
                                {typeof departmentData !== "undefined"
                                  ? departmentData.map((_el) => (
                                      <MenuItem value={_el.id}>
                                        {_el.name}
                                      </MenuItem>
                                    ))
                                  : null}
                              </Select>
                              <ErrorMessage
                                name="idDepartment"
                                component="span"
                                className={classes.error}
                              />
                            </Stack>
                          </Stack>
                        </Grid>
                      </Grid>
                      <Grid
                        container
                        sx={{ pb: 2 }}
                        className={classes.form_add_course}
                        spacing={6}
                      >
                        <Grid item lg={6} md={6} sx={{ width: "100%" }}>
                          <Stack
                            sx={{
                              flexDirection: "row",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <Stack>
                              <Typography className={classes.label}>
                                No of Seats
                              </Typography>
                            </Stack>
                            <Stack>
                              <TextField
                                id="totalSeats"
                                name="totalSeats"
                                placeholder="Enter no of seat"
                                className={
                                  errors.totalSeats && touched.totalSeats
                                    ? classes.inputError
                                    : classes.inputNoError
                                }
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.totalSeats}
                              />
                            </Stack>
                          </Stack>
                        </Grid>
                      </Grid>
                      <Grid
                        container
                        className={classes.form_add_course}
                        spacing={6}
                      >
                        <Grid item lg={6} md={6} sx={{ width: "100%" }}>
                          <Stack
                            sx={{
                              flexDirection: "row",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <Stack>
                              <Typography className={classes.label}>
                                Year of Induction
                              </Typography>
                            </Stack>
                            <Stack>
                              <TextField
                                id="yearOfInduction"
                                name="yearOfInduction"
                                placeholder="Enter year of induction"
                                className={
                                  errors.yearOfInduction &&
                                  touched.yearOfInduction
                                    ? classes.inputError
                                    : classes.inputNoError
                                }
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.yearOfInduction}
                              />
                            </Stack>
                          </Stack>
                        </Grid>
                      </Grid>
                      <Grid container sx={{ py: 4 }}>
                        <Grid item lg={6} md={6} sx={{ width: "100%" }}>
                          <Stack
                            sx={{
                              flexDirection: "column",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <Button
                              type="submit"
                              sx={{ px: 1, py: 1, mb: 2, borderRadius: "50px" }}
                              className={classes.add_course_btn}
                            >
                              Update Course
                            </Button>
                            <Button
                              type="button"
                              sx={{ px: 1, py: 1, borderRadius: "50px" }}
                              className={classes.cancel_btn}
                              onClick={() => navigate(-1)}
                            >
                              Cancel
                            </Button>
                          </Stack>
                        </Grid>
                      </Grid>
                    </form>
                  );
                }}
              </Formik>
            </Stack>
          </Grid>
          <Grid item lg={4} sm={12}></Grid>
        </Grid>
      </Stack>
    </>
  );
};

export default EditCourse;
